import { render, staticRenderFns } from "./specs-column.vue?vue&type=template&id=e222ca18&scoped=true&"
import script from "./specs-column.vue?vue&type=script&lang=js&"
export * from "./specs-column.vue?vue&type=script&lang=js&"
import style0 from "./specs-column.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./specs-column.vue?vue&type=style&index=1&id=e222ca18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e222ca18",
  null
  
)

export default component.exports